import createIcon from '../../createIcon';

/**
 * @component @name ExpandMore
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNTkgOC4yOTQ5MkwxMiAxMi44NzQ5TDcuNDEgOC4yOTQ5Mkw2IDkuNzA0OTJMMTIgMTUuNzA0OUwxOCA5LjcwNDkyTDE2LjU5IDguMjk0OTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ExpandMore = createIcon('ExpandMore', [
  [
    'path',
    {
      d: 'M16.59 8.29492L12 12.8749L7.41 8.29492L6 9.70492L12 15.7049L18 9.70492L16.59 8.29492Z',
      key: '1h4imv',
    },
  ],
]);

export default ExpandMore;
